import React from 'react'
import arrowIcon from "../../../assets/back-arrow.svg"
import "./goBackButton.scss"

type TGoBackButton = { 
	onClick?: any;
}

const GoBackButton = ({onClick = () => {}}: TGoBackButton) => {
  return (
	<button className="t-back-button" onClick={onClick}>
		<img src={arrowIcon} alt="Ir atrás" />
		<p>Volver</p>
	</button>
  )
}

export default GoBackButton